import { Divider } from '@mui/material';
import {
  AdvancedSearchProps,
  ChipsInput,
  SimpleSelect,
} from '@prismamedia/one-components';
import { useGetCategory } from 'apollo/queries/categories.recipe.graphql';
import clsx from 'clsx';
import { FC } from 'react';
import { CategorySelect } from './CategorySelect';
import {
  calorieLevels,
  difficulties,
  estimatedCosts,
  timeValues,
} from './selectsValues';
import { useStyles } from './styles';

export const RecipeAdvancedSearch: FC<AdvancedSearchProps> = ({
  searchParams,
  updateSearchParam,
  brandKey,
}) => {
  const classes = useStyles();
  const { data } = useGetCategory(searchParams.mainCategory);

  return (
    <>
      <div className={classes.section}>
        <CategorySelect
          label="Catégorie principale"
          category={data?.category}
          onSelect={(cat) => {
            updateSearchParam('mainCategory')(cat?.id);
          }}
          className={classes.input}
          brandKey={brandKey}
          displayCount
        />
        <ChipsInput
          label="Tags"
          value={searchParams.tags}
          onChange={updateSearchParam('tags')}
          className={classes.input}
        />
        <ChipsInput
          label="Ingrédients"
          value={searchParams.ingredients}
          onChange={updateSearchParam('ingredients')}
          className={classes.input}
        />
      </div>
      <Divider />
      <div className={classes.section}>
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Difficulté"
          variant="standard"
          options={difficulties}
          value={searchParams.difficulty}
          onChange={(_, value) => updateSearchParam('difficulty')(value)}
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Niveau de prix"
          variant="standard"
          options={estimatedCosts}
          value={searchParams.estimatedCost}
          onChange={(_, value) => updateSearchParam('estimatedCost')(value)}
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Taux de calories"
          variant="standard"
          options={calorieLevels}
          value={searchParams.calorieLevel}
          onChange={(_, value) => updateSearchParam('calorieLevel')(value)}
        />
      </div>
      <Divider />
      <div className={classes.section}>
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Temps de préparation"
          variant="standard"
          options={timeValues}
          value={searchParams.maxPrepTime}
          onChange={(_, value) => updateSearchParam('maxPrepTime')(value)}
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Temps de cuisson"
          variant="standard"
          options={timeValues}
          value={searchParams.maxCookTime}
          onChange={(_, value) => updateSearchParam('maxCookTime')(value)}
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Temps d'attente"
          variant="standard"
          options={timeValues}
          value={searchParams.maxWaitTime}
          onChange={(_, value) => updateSearchParam('maxWaitTime')(value)}
        />
      </div>
    </>
  );
};
